import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Printer } from 'lucide-react';
import MayanLogo from '../common/MayanLogo';
import { company } from '@/data/company';
import { contact } from '@/data/contact';
import { footerQuickLinks, footerLegalLinks } from '@/data/nav';
import { services } from '@/data/services';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-4">
            <MayanLogo className="h-12" />
            <p className="text-gray-600 text-sm leading-relaxed">
              {company.tagline} Established in {company.foundedYear}.
            </p>
          </div>

          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {footerQuickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-600 hover:text-[#398024] transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              {services.slice(0, 5).map((service) => (
                <li key={service.slug}>
                  <Link to="/services" className="text-gray-600 hover:text-[#398024] transition-colors text-sm">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-gray-600 text-sm">
                <MapPin size={18} className="text-[#398024] mt-0.5 flex-shrink-0" />
                <span>{contact.addressShort}</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-600 text-sm">
                <Phone size={18} className="text-[#398024] flex-shrink-0" />
                <a href={contact.phoneHref} className="hover:text-[#398024]">
                  {contact.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center space-x-3 text-gray-600 text-sm">
                <Printer size={18} className="text-[#398024] flex-shrink-0" />
                <span>{contact.faxDisplay}</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-600 text-sm">
                <Mail size={18} className="text-[#398024] flex-shrink-0" />
                <a href={`mailto:${contact.email}`} className="hover:text-[#398024]">
                  {contact.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            {footerLegalLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-gray-600 hover:text-[#398024] transition-colors text-sm"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
